import React, { Component } from "react";
import Grid from "../Grid/Grid";
import GridItem from "../GridItem/GridItem";
import Embed from "../Embed/Embed";
import { FileDownload } from "../FileDownload/FileDownload";
import "../../templates/blogPost.css";

const CSS_CLASSES = {
  IMAGE_WRAPPER: "coop-c-image__wrapper",
  DEFAULT_IMAGE_MARGIN:
    "coop-u-margin-0 coop-u-margin-resp-b-48-32 coop-u-margin-resp-t-48-32",
  FULL_WIDTH_IMAGE: "coop-c-image--full-width",
  POST_INTRO: "coop-c-postcontent__intro",
  REMOVE_BOTTOM_MARGIN: "coop-u-margin-b-0",
};

class ContentBlocks extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pageComponents: null,
    };
  }
  componentDidMount() {
    const gridSizeMap = {
      CORE_IMAGE: {
        size: {
          medium: 12,
          large: 8,
        },
        className: `${CSS_CLASSES.DEFAULT_IMAGE_MARGIN} ${CSS_CLASSES.IMAGE_WRAPPER}`,
      },
      CORE_EMBED: {
        size: {
          medium: 12,
          large: 8,
        },
      },
      CORE_FILE: {
        size: {
          medium: 10,
          large: 6,
        },
      },
      default: {
        size: {
          medium: 10,
          large: 6,
        },
      },
    };

    const structure = this.buildPageStructureFromBlocks(
      gridSizeMap,
      this.props.blocks
    );
    const comps = this.buildPageComponentsFromStructure(structure);

    this.setState({
      pageComponents: comps,
    });
  }

  getAttributeFromBlock(block, attributeName) {
    let data = "";

    if (block.attributes && block.attributes.length) {
      data = block.attributes.find((attribute) => {
        return attribute.name === attributeName;
      });
    }

    return data;
  }

  getClassNameFromBlock(block) {
    function padClassNameWithLeadingSpace(className) {
      return className.padStart(1 + className.length, " ");
    }

    let classNameData = this.getAttributeFromBlock(block, "className");

    if (classNameData && classNameData !== "") {
      return padClassNameWithLeadingSpace(classNameData.value);
    }
    return "";
  }

  getValueByKey(data, key) {
    let dataByKey = this.getAttributeFromBlock(data, key);
    return dataByKey ? `${dataByKey.value}` : ``;
  }

  buildPageStructureFromBlocks(gridSizeMap, blockList) {
    let pageStructure = [];

    function isFullBleedImage(attribute) {
      return attribute.value === "is-style-fullbleed-image";
    }

    blockList.forEach((block) => {
      const map = gridSizeMap[block.type] || gridSizeMap["default"];
      let size = map.size;
      let className = map.className || "";

      className += this.getClassNameFromBlock(block);

      if (block.attributes && block.attributes.find(isFullBleedImage)) {
        size.large = "12";
        className = `${CSS_CLASSES.IMAGE_WRAPPER} ${CSS_CLASSES.FULL_WIDTH_IMAGE}`;
      }

      if (pageStructure.length === 0) {
        pageStructure.push({
          size: size,
          blocks: [
            {
              className: `${CSS_CLASSES.POST_INTRO}  ${className}`,
              ...block,
            },
          ],
        });
      } else {
        let lastGrid = pageStructure[pageStructure.length - 1];

        if (size.large === lastGrid.size.large) {
          lastGrid.blocks.push({
            className: className,
            ...block,
          });
        } else {
          pageStructure.push({
            size: size,
            blocks: [
              {
                className: className,
                ...block,
              },
            ],
          });
        }
      }
    });

    if (blockList.length !== 0) {
      let last = pageStructure[pageStructure.length - 1];
      let lastBlock = last.blocks[last.blocks.length - 1];
      lastBlock.className += ` ${CSS_CLASSES.REMOVE_BOTTOM_MARGIN}`;
    }

    return pageStructure;
  }

  buildComponentFromType(blockType, blockData, index) {
    const componentMap = {
      CORE_EMBED: (data, key) => {
        return (
          <Embed
            key={`ingrid_${key}`}
            url={this.getValueByKey(data, "url")}
            className={data.className}
          />
        );
      },
      CORE_FILE: (data, key) => {
        return (
          <FileDownload
            key={`ingrid_${key}`}
            coreFileDatabaseId={this.getValueByKey(data, "id")}
            mediaItemUrl={this.getValueByKey(data, "href")}
            mediaItemContent={this.props.mediaObject}
          />
        );
      },
      CORE_SEPARATOR: (data, key) => {
        return (
          <>
            <hr />
          </>
        );
      },
      default: (data, key) => {
        const Tag = `${data.tagName}`;
        const className = data.className || null;
        return (
          <Tag
            key={`ingrid_${key}`}
            dangerouslySetInnerHTML={{ __html: data.innerHtml }}
            className={className}
          />
        );
      },
    };

    const componentBuildFunction =
      componentMap[blockType] || componentMap["default"];
    return componentBuildFunction(blockData, index);
  }

  buildPageComponentsFromStructure(pageStructure) {
    const pageComponents = pageStructure.map((gridBlock, index) => {
      const blocks = gridBlock.blocks.map((block, index) => {
        return this.buildComponentFromType(block.type, block, index);
      });

      return (
        <Grid center key={index}>
          <GridItem md={gridBlock.size.medium} lg={gridBlock.size.large}>
            {blocks}
          </GridItem>
        </Grid>
      );
    });

    return pageComponents;
  }

  render() {
    return (
      <>
        <div className="coop-c-postcontent">{this.state.pageComponents}</div>
      </>
    );
  }
}

export default ContentBlocks;
